/**
 * The DharmaTN mark: a balance scale, in the gold the rest of the site uses.
 *
 * One component for every place the name appears — the public header, the customer and admin
 * rails, the advocate portal, the sign-in card, the footer. It replaced a plain gold dot, which
 * said nothing about what this business does; a set of scales says "legal" before the word next to
 * it is read.
 *
 * Kept as a component rather than pasted per layout so the mark cannot drift between portals. The
 * matching browser-tab icon is `public/favicon.svg`, which draws the same paths — if this changes,
 * that file has to change with it, and that is the only duplication of it that exists.
 */
import { Scale } from "lucide-react";

/**
 * @param {string} size  tailwind sizing classes for the glyph
 * @param {string} className extra classes for the wrapper
 */
export function BrandMark({ size = "w-4 h-4", className = "" }) {
  return (
    <Scale
      className={`${size} text-[#CBA96C] shrink-0 ${className}`}
      strokeWidth={1.5}
      // Decorative: the word "DharmaTN" is always beside it, so a screen reader announcing the icon
      // as well would just read the brand twice.
      aria-hidden="true"
    />
  );
}

export default BrandMark;
